var map = {
	"./viewDashboard.vue": [
		3621
	],
	"./viewHeader.vue": [
		9574
	],
	"./viewLessons.vue": [
		3644,
		644
	],
	"./viewLoginOrSignup.vue": [
		6539
	],
	"./viewPWActivation.vue": [
		3213
	],
	"./viewPolicy.vue": [
		2160
	],
	"./viewProductRecommendation.vue": [
		9538,
		538
	],
	"./viewStatisticHints.vue": [
		1146,
		146
	],
	"./viewTasks.vue": [
		8215
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2513;
module.exports = webpackAsyncContext;